import { Entity } from './Entity';
import { POWERUP_TYPES, PowerUpConfig, getRandomPowerUp } from '../config/powerups';

export class PowerUp implements Entity {
  public x: number;
  public y: number;
  public width: number = 60;
  public height: number = 60;
  public active: boolean = true;

  private vy: number; // vertical speed matching original
  private config: PowerUpConfig;
  private floatTimer: number = 0;
  private ttl: number = 10000; // 10 second lifetime
  private age: number = 0;

  constructor(x: number, y: number, type?: string) {
    this.x = x;
    this.y = y;
    
    // Random vertical speed matching original (130-160)
    this.vy = 130 + Math.random() * 30;
    
    if (type && POWERUP_TYPES[type.toUpperCase()]) {
      this.config = POWERUP_TYPES[type.toUpperCase()];
    } else {
      this.config = getRandomPowerUp();
    }
  }

  public getConfig(): PowerUpConfig {
    return this.config;
  }

  public update(deltaTime: number): void {
    this.floatTimer += deltaTime;
    this.age += deltaTime * 1000;
    
    // Move down with consistent speed (matching original vy: 130-160)
    this.y += this.vy * deltaTime;
    
    // Slight horizontal wobble
    this.x += Math.sin(this.floatTimer * 3) * 0.5;

    // Deactivate if off screen or expired
    if (this.y > 960 || this.age >= this.ttl) {
      this.active = false;
    }
  }

  public render(ctx: CanvasRenderingContext2D): void {
    ctx.save();
    ctx.translate(this.x, this.y);

    // Pulsing glow effect
    const glow = 0.7 + Math.sin(this.floatTimer * 5) * 0.3;
    ctx.shadowBlur = 15 * glow;
    ctx.shadowColor = this.config.color;

    // Draw power-up icon
    ctx.fillStyle = this.config.color;
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 2;
    
    // Smiley face
    // Face circle
    ctx.beginPath();
    ctx.arc(0, 0, this.width / 2, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();
    
    // Eyes
    ctx.fillStyle = '#000000';
    ctx.beginPath();
    ctx.arc(-this.width / 6, -this.width / 8, this.width / 12, 0, Math.PI * 2);
    ctx.arc(this.width / 6, -this.width / 8, this.width / 12, 0, Math.PI * 2);
    ctx.fill();
    
    // Smile
    ctx.strokeStyle = '#000000';
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.arc(0, this.width / 12, this.width / 3, 0, Math.PI);
    ctx.stroke();

    ctx.restore();
  }

  public getBounds(): { x: number; y: number; width: number; height: number } {
    return {
      x: this.x - this.width / 2,
      y: this.y - this.height / 2,
      width: this.width,
      height: this.height,
    };
  }

  public getType(): string {
    return this.config.type;
  }
}
